<template>
  <div>
    <v-btn
      v-for="(filter, index) in filters"
      v-if="filter.type !== 'hidden'"
      :key="index"
      round
      small
      color="primary"
      dark
      class="ml-0 px-3 text-none mt-3"
      @click="$emit('filter-removed', index)"
    >
      <span>{{ renderFilter(filter) }}</span>
      <v-icon
        small
      >
        close
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import Money from 'js-money'
import { mapGetters } from 'vuex'

export default {
  name: 'FilterButtons',

  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters(['currency'])
  },

  methods: {
    renderFilter (filter) {
      let filterString = filter.label

      if (filter.type === 'date') {
        if (filter.from) {
          filterString += ` from ${filter.from}`
        }

        if (filter.to) {
          filterString += ` to ${filter.to}`
        }

        return filterString
      }

      filterString += ` ${filter.operator} `

      if (filter.type === 'money') {
        filterString += Money.fromInteger({ amount: parseInt(filter.value), currency: this.currency })
        return filterString
      }

      filterString += filter.value
      return filterString
    }
  }
}
</script>
